export function GetFlagAndWeightage(
    displayName: string,
    flagConfig: Record<string, any>,
    ciBandDisplayToResponseKey: Record<string, string>
) {
    const responseKey = ciBandDisplayToResponseKey[displayName];
    const flag = flagConfig && flagConfig[responseKey];
    const weightage = flag && typeof flag?.weightage !== 'undefined' ? flag?.weightage : '-';
    return { responseKey, flag, weightage };
}

export const isAnyToastVisible = () => document.querySelector('.Toastify__toast');

export const preventInvalidNumberInput = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const blocked = ['e', 'E'];
    if (blocked.includes(e.key)) {
        e.preventDefault();
    }
};

export const handlePasteNumeric = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const paste = e.clipboardData.getData('text');
    if (!/^\d*$/.test(paste)) {
        e.preventDefault();
    }
};



